module.exports = __webpack_public_path__ + "img/radio-selected.db421fb7.svg";